import Box from '@mui/material/Box';

const daysOfTheWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
];
const today = new Date();

export function PrepList(props: any) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evently',
                }}
            >
                {[-1, 0, 1, 2, 3, 4, 5, 6].map((count) => {
                    return (
                        <Box
                            key={count}
                            width={count >= 0 ? 'stretch' : ''}
                            minWidth={count >= 0 ? '' : '96px'}
                            sx={{
                                borderStyle: 'solid',
                                borderColor: 'black',
                                borderWidth: '2px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Box>
                                {count >= 0 &&
                                    daysOfTheWeek[(today.getDay() + count) % 7]}
                            </Box>
                            <Box>
                                {count >= 0 &&
                                    `${today.getMonth() + 1}/${
                                        today.getDate() + count
                                    }/${today.getFullYear()}`}
                            </Box>
                        </Box>
                    );
                })}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evently',
                }}
            >
                {[-1, 0, 1, 2, 3, 4, 5, 6].map((count) => {
                    return (
                        <Box
                            key={count}
                            width={count >= 0 ? 'stretch' : ''}
                            minWidth={count >= 0 ? '' : '100px'}
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            {count >= 0 ? (
                                <Box
                                    width="stretch"
                                    sx={{
                                        borderStyle: '',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <Box
                                        width="60px"
                                        sx={{
                                            textAlign: 'center',
                                            borderStyle: 'solid',
                                            borderColor: 'black',
                                            borderWidth: '2px',
                                        }}
                                    >
                                        PAR's
                                    </Box>
                                    <Box
                                        width="60px"
                                        sx={{
                                            textAlign: 'center',
                                            borderStyle: 'solid',
                                            borderColor: 'black',
                                            borderWidth: '2px',
                                        }}
                                    >
                                        Build To
                                    </Box>
                                    <Box
                                        width="60px"
                                        sx={{
                                            textAlign: 'center',
                                            borderStyle: 'solid',
                                            borderColor: 'black',
                                            borderWidth: '2px',
                                        }}
                                    >
                                        Count
                                    </Box>
                                    <Box
                                        width="60px"
                                        sx={{
                                            textAlign: 'center',
                                            borderStyle: 'solid',
                                            borderColor: 'black',
                                            borderWidth: '2px',
                                        }}
                                    >
                                        Prep
                                    </Box>
                                </Box>
                            ) : (
                                <Box
                                    height="100%"
                                    width="96px"
                                    sx={{
                                        borderStyle: 'solid',
                                        borderColor: 'black',
                                        borderWidth: '2px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                    }}
                                >
                                    Item Name
                                </Box>
                            )}
                        </Box>
                    );
                })}
            </Box>
            {props.data.map((prepItem: any, index: number) => {
                return (
                    <Box
                        key={index}
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evently',
                        }}
                    >
                        {[-1, 0, 1, 2, 3, 4, 5, 6].map((count) => {
                            return (
                                <Box
                                    key={count}
                                    width={count >= 0 ? 'stretch' : ''}
                                    minWidth={count >= 0 ? '' : '100px'}
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Box width="stretch" height="stretch">
                                        {count >= 0 ? (
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent:
                                                        'space-evenly',
                                                }}
                                            >
                                                <Box
                                                    width="60px"
                                                    sx={{
                                                        textAlign: 'center',
                                                        borderStyle: 'solid',
                                                        borderColor: 'black',
                                                        borderWidth: '2px',
                                                    }}
                                                >
                                                    {Math.ceil(
                                                        prepItem.prepAmount[
                                                            count
                                                        ]
                                                    )}
                                                </Box>
                                                <Box
                                                    width="60px"
                                                    sx={{
                                                        textAlign: 'center',
                                                        borderStyle: 'solid',
                                                        borderColor: 'black',
                                                        borderWidth: '2px',
                                                    }}
                                                >
                                                    {Math.ceil(
                                                        prepItem.prepAmount[
                                                            count
                                                        ]
                                                    )}
                                                </Box>
                                                <Box
                                                    width="60px"
                                                    sx={{
                                                        textAlign: 'center',
                                                        borderStyle: 'solid',
                                                        borderColor: 'black',
                                                        borderWidth: '2px',
                                                    }}
                                                ></Box>
                                                <Box
                                                    width="60px"
                                                    sx={{
                                                        textAlign: 'center',
                                                        borderStyle: 'solid',
                                                        borderColor: 'black',
                                                        borderWidth: '2px',
                                                    }}
                                                >
                                                    {Math.ceil(
                                                        prepItem.prepAmount[
                                                            count
                                                        ]
                                                    )}
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box
                                                width="96px"
                                                sx={{
                                                    borderStyle: 'solid',
                                                    borderColor: 'black',
                                                    borderWidth: '2px',
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                {prepItem.name}
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                            );
                        })}
                    </Box>
                );
            })}
        </Box>
    );
}
